import { jsx as i, jsxs as v } from "react/jsx-runtime";
import { createContext as w, forwardRef as f, useMemo as g, useContext as I } from "react";
import { useValues as N } from "./chart-utils.js";
import { useId as L } from "../../utils.js";
import C from "clsx";
import e from "../chart.module.css.js";
const h = { total: 0, direction: "horizontal", grouping: "spread" }, A = w(h), E = f(
  function({ children: a, className: r, style: t, variant: n = h.direction, ...c }, o) {
    const [s, u = h.grouping] = n.split("-"), [l, p] = N(o), { steps: x, total: d } = g(() => V(l), [l]), b = { ...t, "--total": d }, G = C(
      e.axis,
      e[`is-${s}`],
      e[`is-${u}`],
      r
    );
    return /* @__PURE__ */ i(A.Provider, { value: { total: d, direction: s, grouping: u }, children: /* @__PURE__ */ v("div", { className: G, style: b, ref: p, ...c, children: [
      /* @__PURE__ */ i("div", { className: e.axisValues, "aria-hidden": "true", children: [...x].reverse().map((y, M) => /* @__PURE__ */ i("div", { className: e.axisValue, children: /* @__PURE__ */ i("div", { className: e.axisLabel, children: y }) }, M)) }),
      /* @__PURE__ */ i("div", { className: e.axisGroups, children: a })
    ] }) });
  }
), P = f(
  function({ className: a, children: r, label: t, ...n }, c) {
    const { grouping: o } = I(A), [s, u] = N(c), l = L(), p = g(() => o === "spread" || !s.length ? 0 : s.reduce((x, { value: d }) => x + d, 0), [o, s]);
    return /* @__PURE__ */ v(
      "div",
      {
        role: "group",
        "aria-labelledby": l,
        className: C(e.axisGroup, a),
        "data-legend": "skip",
        "data-value": p,
        ref: u,
        ...n,
        children: [
          /* @__PURE__ */ i("div", { className: e.axisGroupContent, children: r }),
          /* @__PURE__ */ i("div", { className: e.axisLabel, "aria-hidden": "true", id: l, children: t })
        ]
      }
    );
  }
), R = new Intl.NumberFormat().format, V = (m) => {
  const a = m.reduce((o, { value: s }) => Math.max(o, s), 0), r = Math.pow(10, `${~~a}`.length - 1), t = a / r < 5 ? r / 2 : r, n = Math.ceil(a / t) * t, c = [...Array(n / t + 1)].map((o, s) => R(t * s));
  return { total: n, steps: c };
};
export {
  E as ChartAxis,
  A as ChartAxisContext,
  P as ChartAxisGroup
};
//# sourceMappingURL=chart-axis.js.map
